import { Country } from '@urc-ui/store/api/countries/types';
import { FILTER_TYPES } from '@urc-ui/utils/types';
import { CustomReportType } from '@urc-ui/store/api/report-metadata/types';
import { mapToCountryList } from '@urc-ui/utils/marketplace-utils';
import { CAMPAIGN_SITE_FILTER_VALUE_AMAZON_BUSINESS } from '@urc-ui/store/api/ross/constants/filter-constants';

export const isAmazonBusinessReportEnabled = (customReportType: CustomReportType | null): boolean => {
  if (!customReportType) {
    return false;
  }
  return customReportType?.filterTypes.includes(FILTER_TYPES.CAMPAIGN_SITE_FILTER_TYPE);
};

export const isAmazonBusinessCheckboxSelected = (filters?: any[]): boolean => {
  const abFilter = filters?.find(filter => filter.id === FILTER_TYPES.CAMPAIGN_SITE_FILTER_TYPE);
  return abFilter?.values?.[0]?.[FILTER_TYPES.CAMPAIGN_SITE_FILTER_TYPE] === CAMPAIGN_SITE_FILTER_VALUE_AMAZON_BUSINESS || false;
};

export const getAmazonBusinessMarketplaces = (): Country[] => {
  return mapToCountryList(window.AppContext?.ABMarketplaces);
};

export const filterAmazonBusinessMarketplaces = (countries: Country[]): Country[] => {
  const abMarketplaces = getAmazonBusinessMarketplaces();
  return countries.filter(country =>
    abMarketplaces.some(
      abMarketplace => country.countryCode === abMarketplace.countryCode && country.marketplaceId === abMarketplace.marketplaceId
    )
  );
};

export const filterNonAmazonBusinessMarketplaces = (countries: Country[]): Country[] => {
  const abMarketplaces = getAmazonBusinessMarketplaces();
  return countries.filter(
    country =>
      !abMarketplaces.some(
        abMarketplace => country.countryCode === abMarketplace.countryCode && country.marketplaceId === abMarketplace.marketplaceId
      )
  );
};

export const filterNonAmazonBusinessCountryCodes = (countries: Country[]): string[] => {
  const abMarketplaces = getAmazonBusinessMarketplaces();
  return countries
    .filter(
      country =>
        !abMarketplaces.some(
          abMarketplace => country.countryCode === abMarketplace.countryCode && country.marketplaceId === abMarketplace.marketplaceId
        )
    )
    .map(country => country.countryCode);
};

export const SITE_AMAZON_BUSINESS = 'AmazonBusiness';
